import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ReviewLayout } from '../components/ReviewLayout';

const profileFiles = import.meta.glob('../data/firms/*/profile.json');
const discountFiles = import.meta.glob('../data/firms/*/discount.json');
const detailsFiles = import.meta.glob('../data/firms/*/details.json');
const reviewsFiles = import.meta.glob('../data/firms/*/reviews.json');

export const ReviewDetailPage = () => {
  const { firmSlug } = useParams();
  const [firm, setFirm] = useState<any>(null);
  const [discount, setDiscount] = useState<any>(null);
  const [details, setDetails] = useState<any>(null);
  const [reviews, setReviews] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [notFound, setNotFound] = useState<boolean>(false);

  useEffect(() => {
    if (!firmSlug) {
      setNotFound(true);
      setLoading(false);
      return;
    }

    const loadData = async () => {
      try {
        const profilePath = `../data/firms/${firmSlug}/profile.json`;
        const discountPath = `../data/firms/${firmSlug}/discount.json`;
        const detailsPath = `../data/firms/${firmSlug}/details.json`;
        const reviewsPath = `../data/firms/${firmSlug}/reviews.json`;

        if (!profileFiles[profilePath]) {
          setNotFound(true);
          return;
        }

        const [profileData, discountData, detailsData, reviewsData] = await Promise.all([
          profileFiles[profilePath]().then((m: any) => m.default),
          discountFiles[discountPath]?.().then((m: any) => m.default).catch(() => null),
          detailsFiles[detailsPath]?.().then((m: any) => m.default).catch(() => null),
          reviewsFiles[reviewsPath]?.().then((m: any) => m.default).catch(() => null),
        ]);

        setFirm(profileData);
        setDiscount(discountData);
        setDetails(detailsData);
        setReviews(reviewsData);
      } catch (error) {
        console.error('Error loading firm data:', error);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [firmSlug]);

  if (loading) {
    return (
      <div className="max-w-screen-xl mx-auto p-8 text-center text-yellow-300">
        Loading firm data...
      </div>
    );
  }

  if (notFound || !firm) {
    return (
      <div className="max-w-screen-xl mx-auto p-8 text-center text-yellow-300">
        Firm not found. Please check back later.
      </div>
    );
  }

  return (
    <ReviewLayout
      firm={{ ...firm, evaluation: { ...firm.evaluation, discount } }}
      details={details}
      reviewsData={reviews}
    />
  );
};

export default ReviewDetailPage;
